import request from '@/utils/request'
const apiPath = '/sys/tongshangyun'
const sysTongshangyunApi = {
  /**
   * 注册企业会员
   */
  registerCompanyMember(query) {
    return request.get(`${apiPath}/registerCompanyMember`, { params: query })
  },
  //获取会员信息
  getMemberInfo(query){
    return request.get(`${apiPath}/getMemberInfo`, { params: query })
  }
}
export default sysTongshangyunApi
